import Vue from "vue";
import Vuex from "vuex";
import user from "../store/user"
import common from "../store/common";
import places from "../store/places";
import personalDetailsModule from "../store/personalDetails";
import bankDetailsModule from "../store/bankDetails";
import contactDetailsModule from "../store/contactDetails";
import employmentDetailsModule from "../store/employmentDetails";
import employmentHistoryModule from "../store/employmentHistory";
import highestEducationModule from "../store/highestEducation";
import proposedStudyModule from "../store/proposedStudy";
import addressBookModule from "../store/addressBook";
import spmResultModule from "../store/spmResult";
import dependentDetailsModule from "./dependentDetails";

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    user,
    common,
    places,
    addressBook: addressBookModule,

    appPersonalDetails: personalDetailsModule,
    appContactDetails: contactDetailsModule,
    appPermanentAddress: addressBookModule,
    appMailAddress: addressBookModule,
    appEmploymentDetails: employmentDetailsModule,
    appEmploymentHistory: employmentHistoryModule,
    appBankDetails: bankDetailsModule,
    appHighestEducation: highestEducationModule,
    appProposedStudy: proposedStudyModule,
    appSpmResult: spmResultModule,
    appDependentDetails: dependentDetailsModule,

    spousePersonalDetails: personalDetailsModule,
    spouseContactDetails: contactDetailsModule,
    spousePersonalAddress: addressBookModule,
    spouseEmploymentContactDetails: contactDetailsModule,
    spouseEmploymentDetails: employmentDetailsModule,
    spouseEmploymentHistory: employmentHistoryModule,

    fatherPersonalDetails: personalDetailsModule,
    fatherContactDetails: contactDetailsModule,
    fatherPersonalAddress: addressBookModule,
    fatherEmploymentContactDetails: contactDetailsModule,
    fatherEmploymentDetails: employmentDetailsModule,
    fatherEmploymentHistory: employmentHistoryModule,

    motherPersonalDetails: personalDetailsModule,
    motherContactDetails: contactDetailsModule,
    motherPersonalAddress: addressBookModule,
    motherEmploymentContactDetails: contactDetailsModule,
    motherEmploymentDetails: employmentDetailsModule,
    motherEmploymentHistory: employmentHistoryModule,

    guardianPersonalDetails: personalDetailsModule,
    guardianContactDetails: contactDetailsModule,
    guardianPersonalAddress: addressBookModule,
    guardianEmploymentContactDetails: contactDetailsModule,
    guardianEmploymentDetails: employmentDetailsModule,
    guardianEmploymentHistory: employmentHistoryModule,

    familyPersonalDetails: personalDetailsModule,
    familyContactDetails: contactDetailsModule,
    familyPersonalAddress: addressBookModule,
    familyEmploymentDetails: employmentDetailsModule,
    familyEmploymentHistory: employmentHistoryModule,
    familyEmploymentContactDetails: contactDetailsModule,

    guarantor1PersonalDetails: personalDetailsModule,
    guarantor1ContactDetails: contactDetailsModule,
    guarantor1PersonalAddress: addressBookModule,
    guarantor1EmploymentHistory: employmentHistoryModule,
    guarantor1EmploymentContactDetails: contactDetailsModule,

    guarantor2PersonalDetails: personalDetailsModule,
    guarantor2ContactDetails: contactDetailsModule,
    guarantor2PersonalAddress: addressBookModule,
    guarantor2EmploymentHistory: employmentHistoryModule,
    guarantor2EmploymentContactDetails: contactDetailsModule,
  }
});
